// e-shot reads the phone's contacts (voip_contacts) directly: no copy, no sync
// (owner, 2026-10-26). A contact's id is the phone contact's own document id.
//
// isSendablePhoneContact is the browser's copy of the server's rule in
// functions/lib/eshot-contacts.js; phoneContacts.test.js runs it over the same
// cases (functions/lib/eshot-sendable.cases.js), so the two cannot drift.

export const PHONE_CONTACTS = 'voip_contacts';
export const PAGE_SIZE = 50;

// The phone's own contact-type chips (apps/voip/src/pages/Contacts.jsx).
export const PHONE_CONTACT_TYPES = [
  { key: 'architect', label: 'Architect' },
  { key: 'nhs-healthcare', label: 'NHS' },
  { key: 'main-contractor', label: 'Contractor' },
  { key: 'specifier', label: 'Specifier' },
  { key: 'distributor', label: 'Distributor' },
  { key: 'facilities-manager', label: 'FM' },
  { key: 'consultant', label: 'Consultant' },
  { key: 'developer', label: 'Developer' },
  { key: 'local-authority', label: 'Local Auth' },
  { key: 'end-user', label: 'End User' },
  { key: 'unknown', label: 'Unknown' },
];

function emailOf(data) {
  return typeof data?.email === 'string' ? data.email.trim().toLowerCase() : '';
}

// Who e-shot may send to: an email address, still at the company, still in
// Gold-Vision, and never a training contact.
export function isSendablePhoneContact(data) {
  if (!data || typeof data !== 'object') return false;
  const email = emailOf(data);
  if (!email || !/^[^\s@]+@[^\s@]+$/.test(email)) return false;
  if (data.leftCompany === true) return false;
  if (data.gvRemovedAt) return false;
  if (data.sandbox === true) return false;
  return true;
}

// Shown in the list at all: the phone hides people who have left or been
// removed from Gold-Vision, and e-shot never shows training contacts.
export function isListedPhoneContact(data) {
  return !!data && data.leftCompany !== true && !data.gvRemovedAt && data.sandbox !== true;
}

function str(v) {
  return typeof v === 'string' ? v.trim() : '';
}

// One phone contact in the shape e-shot's pages use.
export function contactFromPhone(id, data) {
  const d = data || {};
  const name = str(d.name) || [str(d.firstName), str(d.lastName)].filter(Boolean).join(' ');
  return {
    id,
    email: emailOf(d),
    name,
    account: str(d.company),
    position: str(d.role) || str(d.position),
    phone: str(d.mobile) || str(d.landline),
    contactType: str(d.contactType),
    companyId: str(d.companyId),
    sendable: isSendablePhoneContact(d),
    _nameLower: str(d._nameLower),
    _companyNormalisedLower: str(d._companyNormalisedLower),
  };
}

// Why a listed contact cannot be added to a send, or '' when it can.
export function notSendableReason(contact) {
  if (!contact) return 'No longer in contacts';
  if (!contact.email) return 'No email';
  if (!contact.sendable) return 'Cannot be emailed';
  return '';
}
